import React from "react";
import styled from "@emotion/styled";
import moment from "moment";
import { injectIntl } from "react-intl";

import { Paper } from "@mui/material";

import Placeholder from "components/Placeholder";
import Section from "components/Section";
import Map from "components/Map";

import Abilities from "services/permissions/abilities";
import CommonUtils from "services/common/utils";
import ParkkiTheme from "themes/ParkkiTheme";
import MapComponent from "./components/MapComponent";

const GraphSection = styled(Paper)`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${ParkkiTheme.spacings.base};
`;

const GraphsContainer = styled.div`
  height: ${(props) => (props?.fullScreen ? "550px" : "350px")};
  width: 100%;
`;
const FooterContainer = styled.div`
  margin-top: ${ParkkiTheme.spacings.small};
`;
const FooterTitle = styled.div``;
const FooterSubtitle = styled.div`
  font-size: ${ParkkiTheme.fontSizes.xsmall};
  color: ${ParkkiTheme.colors.disabledGrey};
`;

function QualitificationCatchmentAreasSection({
  intl,
  visitorCharacteristics,
  fullScreen,
  onRecenter,
}) {
  if (
    !Abilities.ability.can(
      "read",
      "visitorCharacteristics.mapAppDistribution"
    ) &&
    !Abilities.ability.can(
      "read",
      "visitorCharacteristics.fullMapAppDistribution"
    )
  ) {
    return null;
  }

  return (
    <Section
      title={
        intl.messages[
          "visitorCharacteristicsScene.sections.qualificationCatchmentAreas.title"
        ]
      }
    >
      {!visitorCharacteristics?.catchmentAreas?.initialized ? (
        <Placeholder height={fullScreen ? "600px" : "400px"} delay={0} />
      ) : null}

      {visitorCharacteristics?.catchmentAreas?.initialized ? (
        <GraphSection>
          <GraphsContainer fullScreen={fullScreen}>
            <Map
              withCheckboxOptions={{
                aisles: false,
                labels: false,
                displays: false,
                spaceLabels: false,
              }}
              mapComponent={
                <MapComponent
                  visitorCharacteristics={visitorCharacteristics}
                  onRecenter={onRecenter}
                />
              }
              onRecenter={onRecenter}
            />
          </GraphsContainer>
          <FooterContainer>
            <FooterTitle>
              {intl.formatMessage(
                {
                  id: "visitorCharacteristicsScene.sections.qualificationCatchmentAreas.nbConnection",
                },
                {
                  nb_connections:
                    CommonUtils.formatNumber(
                      visitorCharacteristics?.catchmentAreas.nb_connections
                    ) || 0,
                }
              )}
            </FooterTitle>
            <FooterSubtitle>
              {intl.formatMessage(
                {
                  id: "visitorCharacteristicsScene.sections.qualificationCatchmentAreas.fromApp",
                },
                {
                  from: moment(
                    visitorCharacteristics?.filters?.from * 1000
                  ).format("D MMMM YYYY"),
                  to: moment(visitorCharacteristics?.filters?.to * 1000).format(
                    "D MMMM YYYY"
                  ),
                }
              )}
            </FooterSubtitle>
          </FooterContainer>
        </GraphSection>
      ) : null}
    </Section>
  );
}

export default injectIntl(QualitificationCatchmentAreasSection);
